import React, { useEffect, useRef, useState } from 'react';
import Peer from 'peerjs';
import {useSearchParams} from "react-router-dom";

function Video_steamer() {

    const [peerId, setPeerId] = useState('');
    const remoteVideoRef = useRef(null);
    const currentUserVideoRef = useRef(null);
    const peerInstance = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const [remotePeerIdValue, setRemotePeerIdValue] = useState(searchParams.get('tt'));

    useEffect(() => {
        const peer = new Peer();
        console.log(remotePeerIdValue);
        peer.on('open', (id) => {
            setPeerId(id)
        });
        peer.on('call', (call) => {
            var getUserMedia = navigator.getUserMedia
                || navigator.webkitGetUserMedia
                || navigator.mozGetUserMedia;
            getUserMedia({video: true, audio: true}, (mediaStream) => {
                currentUserVideoRef.current.srcObject = mediaStream;
                currentUserVideoRef.current.play();
                call.answer(mediaStream)
                call.on('stream', function (remoteStream) {
                    remoteVideoRef.current.srcObject = remoteStream
                    remoteVideoRef.current.play();
                });
            });
        })
        peerInstance.current = peer;
    }, [])
    const call = (remotePeerId) => {
        var getUserMedia = navigator.getUserMedia
            || navigator.webkitGetUserMedia
            || navigator.mozGetUserMedia;
        getUserMedia({video: true, audio: true}, (mediaStream) => {
            currentUserVideoRef.current.srcObject = mediaStream;
            currentUserVideoRef.current.play();
            const call = peerInstance.current.call(remotePeerId, mediaStream)
            call.on('stream', (remoteStream) => {
                remoteVideoRef.current.srcObject = remoteStream
                remoteVideoRef.current.play();
            });
        });
    }
    return (
        <header className="App-header d-grid gap-2">
            <div className="container-fluid d-grid gap-2 d-print-none" id="tablo">
                <h1 className="text-light pt-3">https://p2pchat.roomab.art?tt={peerId}</h1>
                <button onClick={() => call(remotePeerIdValue)} className="btn btn-primary btn-lg btn-block">Вызвать
                </button>
                <button onClick={() => window.location.reload()} className="btn btn-primary btn-lg btn-block">Выйти
                </button>
                <div className="embed-responsive embed-responsive-21by9">
                    <video ref={remoteVideoRef} id="remote_video" className="embed-responsive-item"/>
                </div>
                <div className="embed-responsive embed-responsive-4by3">
                    <video ref={currentUserVideoRef} id="home_video" className="embed-responsive-item"/>
                </div>

            </div>
        </header>
    );
}

export default Video_steamer;